import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import styles from './styles.module.less';

const REQUEST_CONSULT_LINK = 'https://calendly.com/davis-saltzgiver/fulfilled-by-shipstation-first-onboarding-clone';

export const Body = () => {
  return (
    <Button className={styles['schedule-appointment-button']} href={REQUEST_CONSULT_LINK} target='_blank' theme={THEME_CONSTANTS.primary}>
      <FormattedMessage {...messages.scheduleAppointmentButton} />
      <FontAwesomeIcon className={styles['external-link-icon-button']} icon={faExternalLinkAlt} />
    </Button>
  );
};
